import { render, staticRenderFns } from "./AppSmFooter.vue?vue&type=template&id=35376e86&lang=pug&"
import script from "./AppSmFooter.vue?vue&type=script&lang=js&"
export * from "./AppSmFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports